





































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { Group } from '@/router/group.model';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import CollapseRowV2 from '@/componentsV2/molecules/CollapseRowV2/CollapseRowV2.vue';
import ArrowDownIcon from '@/components/icons/Arrow.vue';

import LeftBarNavGroupHeader from './LeftBarNavGroupHeader.vue';
import LeftBarNavItem from './LeftBarNavItem.vue';
import { getCurrentGroup } from '@/router';

@Component({
  components: {
    Typography,
    LeftBarNavItem,
    CollapseRowV2,
    ArrowDownIcon,
    LeftBarNavGroupHeader
  }
})
export default class TopBarNavSubGroup extends Vue {
  @Prop() group!: Group;
  @Prop(Boolean) readonly viewOnly: boolean | undefined;
  @Prop({ default: false }) mobileTabs?: boolean;
  @Prop() focusedId?: string;

  @Prop() notification?: any;

  opened = false;

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get routes() {
    return this.group.getVisibleRoutes();
  }

  @Watch('$route')
  onRouteChange() {
    const group = getCurrentGroup();
    if (group && this.group) this.opened = group.id === this.group.id;
  }

  clickCollapse(value?: boolean) {
    this.opened = value !== undefined ? value : !this.opened;

    this.$emit('click-collapse', { id: this.group.id, opened: this.opened });
  }

  created() {
    const group = getCurrentGroup();
    this.opened = group.id === this.group.id;
  }
}
